/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define(['../validators', '../converters', '../postValidators', 'common/parameterApplications'],
    /**
     * @private
     * @class CommonRoutingParameters
     * @module Services
     * @uses KeyMixin
     */

    function(validators, converters, postValidators, parameterApplications) {

        var fields = {
            key: {
                validator: validators.string
            },

            /**
             * A setter and getter for 'routeType' attribute.
             * The type of route requested. Notes on specific values:
             * *    fastest returns the fastest route.
             * *    shortest returns the shortest route by distance.
             * *    eco routes balance economy and speed.
             * *    thrilling routes include interesting or challenging roads and use as few motorways as possible.
             * You can choose the level of turns included and also the degree of hilliness. See the hilliness and
             * windingness parameters for how to set this. There is a limit of 900 km on routes planned with
             * routeType=thrilling
             *
             * Default value is fastest
             *
             * @method routeType
             * @chainable
             * @param {String} [routeType] Route type to be used during route calculation.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or route type value if
             *     argument is omitted.
             */
            routeType: {
                validator: validators.oneOfValue(['fastest', 'shortest', 'eco', 'thrilling'], 'route type')
            },

            /**
             * A setter and getter for 'traffic' attribute.
             * 
             * Possible values:
             * - true (just considers all available traffic information during routing)
             * - false (ignores current traffic data during routing). Note that although the current traffic data is
             *   ignored during routing, the effect of historic traffic on effective road speeds is still incorporated.
             * 
             * Default is true
             *
             * @method traffic
             * @chainable
             * @param {Boolean} [traffic] Boolean flag determines if traffic data should be used to calculate the
             *     route.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Boolean} Method returns the service instance allowing chaining or traffic value if
             *     argument is omitted.
             */
            traffic: {
                validator: validators.bool
            },

            /**
             * A setter and getter for 'avoid' attribute.
             * 
             * Specifies something that the route calculation should try to avoid when determining the route. Can be
             * specified multiple times. Possible values:
             * *    tollRoads: avoids toll roads.
             * *    motorways: avoids motorways.
             * *    ferries: avoids ferries.
             * *    unpavedRoads: avoids unpaved roads.
             * *    carpools: avoids routes that require use of carpool (HOV/ High Occupancy Vehicle) lanes.
             * *    alreadyUsedRoads: avoids using the same road multiple times.
             *
             * Most useful in conjunction with routeType=thrilling.
             *
             * @method avoid
             * @chainable
             * @param {Array|String} [avoid] Specifies something that the route calculation should try to avoid when
             *     determining the route
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Array} Method returns the service instance allowing chaining or street number value if
             *     argument is omitted.
             */
            avoid: {
                validator: validators.arrayOfValues(['tollRoads', 'motorways', 'ferries', 'unpavedRoads', 'carpools',
                    'alreadyUsedRoads'
                ], 'avoid'),
                converter: converters.arrayOfStrings
            },

            /**
             * A setter and getter for 'departAt' attribute.
             * 
             * The date and time of departure from the origin point.
             * Departure times apart from now must be specified as a dateTime.
             * When a time zone offset is not specified, it will be assumed to be that of the origin point.
             * The departAt value must be in the future. The departAt parameter cannot be used in conjunction with
             * arriveAt.
             *
             * @method departAt
             * @chainable
             * @param {String} [departAt] The properly formatted date with time or 'now' value. Date cannot be in the
             *     past.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            departAt: {
                validator: validators.departAt,
                converter: converters.dateTime
            },

            /**
             * A setter and getter for 'arriveAt' attribute.
             * 
             * The date and time of arrival at the destination point.
             * It must be specified as a dateTime.
             * When a time zone offset is not specified it will be assumed to be that of the destination point.
             * The arriveAt value must be in the future. The arriveAt parameter cannot be used in conjunction with
             * departAt.
             *
             * @method arriveAt
             * @chainable
             * @param {String} [arriveAt] The properly formatted date with time value. Date cannot be in the past.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            arriveAt: {
                validator: validators.arriveAt,
                converter: converters.dateTime
            },

            /**
             * A setter and getter for 'travelMode' attribute.
             * 
             * The travel mode for the requested route. 
             * 
             * Possible values: _car, truck, taxi, bus, van, motorcycle, bicycle, pedestrian_ 
             * 
             * Note that the requested travelMode may not be available for the entire route. Where
             * the requested travelMode is not available for a particular section, the <travelMode> element of the
             * response for that section will be other.
             *
             * @method travelMode
             * @chainable
             * @param {String} [travelMode] The primary mean of transportation to be used while routing.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            travelMode: {
                validator: validators.oneOfValue(['car', 'truck', 'taxi', 'bus', 'van', 'motorcycle', 'bicycle',
                    'pedestrian'
                ], 'travel mode')
            },

            /**
             * A setter and getter for 'hilliness' attribute.
             * 
             * Degree of hilliness for thrilling route. Possible values: low, normal, high
             * This parameter can only be used in conjunction with routeType thrilling.
             *
             * @method hilliness
             * @chainable
             * @param {String} [hilliness] The level of hilliness on a thrilling route.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            hilliness: {
                validator: validators.oneOfValue(['low', 'normal', 'high'], 'hilliness')
            },

            /**
             * A setter and getter for 'windingness' attribute.
             * 
             * Level of turns for thrilling route. Possible values: low, normal, high
             * This parameter can only be used in conjunction with routeType thrilling.
             *
             * @method windingness
             * @chainable
             * @param {String} [windingness] The level of windingness on a thrilling route.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            windingness: {
                validator: validators.oneOfValue(['low', 'normal', 'high'], 'windingness')
            },

            /**
             * A setter and getter for 'report' attribute.
             * 
             * Specifies which data should be reported for diagnosis purposes. 
             * 
             * Possible values: _effectiveSettings_ 
             * Reports the effective parameters or data used when calling the API.
             * 
             * In the case of defaulted parameters the default will be reflected where the parameter was not specified
             * by the caller.
             *
             * @method report
             * @chainable
             * @param {String} [report] Level of verbose answer from service, useful for debugging purposes.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or language if argument
             *     is omitted.
             */
            report: {
                validator: validators.oneOfValue(['effectiveSettings'], 'report')
            },

            /**
             * A setter and getter for 'vehicleEngineType' attribute.
             * 
             * Engine type of the vehicle. This parameter is currently only considered for travelMode truck. Valid
             * options are: _combustion, electric_
             *
             * @method vehicleEngineType
             * @chainable
             * @param {String} [vehicleEngineType] The vehicle engine type.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleEngineType: {
                validator: validators.oneOfValue(['combustion', 'electric'], 'vehicle engine type')
            },

            /**
             * A setter and getter for 'vehicleMaxSpeed' attribute.
             * 
             * Maximum speed of the vehicle in km/hour. A value of 0 means that an appropriate value for the vehicle
             * will be determined and applied during route planning. A non-zero value may be overridden during route
             * planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleMaxSpeed
             * @chainable
             * @param {Number} [vehicleMaxSpeed] The maximal allowed vehicle speed in km/h.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleMaxSpeed: {
                validator: validators.naturalInteger
            },

            /**
             * A setter and getter for 'vehicleWeight' attribute.
             * 
             * Weight of the vehicle in kg. A value of 0 means that weight restrictions are not considered during route
             * planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleWeight
             * @chainable
             * @param {Number} [vehicleWeight] The vehicle weight in kg.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleWeight: {
                validator: validators.naturalInteger,
                postValidator: postValidators.vehicleWeight
            },

            /**
             * A setter and getter for 'vehicleAxleWeight' attribute.
             * 
             * Weight per axle of the vehicle in kg. A value of 0 means that weight restrictions per axle are not
             * considered during route planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleAxleWeight
             * @chainable
             * @param {Number} [vehicleAxleWeight] The vehicle axle weight in kg.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleAxleWeight: {
                validator: validators.naturalInteger
            },

            /**
             * A setter and getter for 'vehicleLength' attribute.
             * 
             * Length of the vehicle in meters. A value of 0 means that length restrictions are not considered during
             * route planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleLength
             * @chainable
             * @param {Number} [vehicleLength] The vehicle length in m.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleLength: {
                validator: validators.numberInInterval(0, Number.MAX_VALUE)
            },

            /**
             * A setter and getter for 'vehicleWidth' attribute.
             * 
             * Width of the vehicle in meters. A value of 0 means that width restrictions are not considered during
             * route planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleWidth
             * @chainable
             * @param {Number} [vehicleWidth] The vehicle width in m.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleWidth: {
                validator: validators.numberInInterval(0, Number.MAX_VALUE)
            },

            /**
             * A setter and getter for 'vehicleHeight' attribute.
             * 
             * Height of the vehicle in meters. A value of 0 means that height restrictions are not considered
             * during route planning. This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleHeight
             * @chainable
             * @param {Number} [vehicleHeight] The vehicle height in m.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleHeight: {
                validator: validators.numberInInterval(0, Number.MAX_VALUE)
            },

            /**
             * A setter and getter for 'vehicleCommercial' attribute.
             * 
             * Vehicle is used for commercial purposes and thus may not be allowed to drive on some roads. This
             * parameter is currently only considered for travelMode truck.
             *
             * @method vehicleCommercial
             * @chainable
             * @param {Boolean} [vehicleCommercial] True if vehicle is used for commercial purposes.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleCommercial: {
                validator: validators.bool
            },

            /**
             * A setter and getter for 'vehicleLoadType' attribute.
             * 
             * Types of cargo that may be classified as hazardous materials and restricted from some roads. Available
             * vehicleLoadType values are US Hazmat classes 1 through 9, plus generic classifications for use in other
             * countries.
             *
             * __Use these for routing in US__
             * * USHazmatClass1 Explosives
             * * USHazmatClass2 Compressed gas
             * * USHazmatClass3 Flammable liquids
             * * USHazmatClass4 Flammable solids
             * * USHazmatClass5 Oxidizers
             * * USHazmatClass6 Poisons
             * * USHazmatClass7 Radioactive
             * * USHazmatclass8 Corrosives
             * * USHazmatClass9 Miscellaneous
             *
             * __Use these for routing in all other countries__
             * * otherHazmatExplosive Explosives
             * * otherHazmatGeneral Miscellaneous
             * * otherHazmatHarmfulToWater Harmful to water
             *
             * This parameter is currently only considered for travelMode truck.
             *
             * @method vehicleLoadType
             * @chainable
             * @param {Array|String} [vehicleLoadType] The array of truck cargo classification.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Array} Method returns the service instance allowing chaining or current value if
             *     argument is omitted.
             */
            vehicleLoadType: {
                validator: validators.arrayOfValues(['USHazmatClass1', 'USHazmatClass2', 'USHazmatClass3',
                    'USHazmatClass4', 'USHazmatClass5', 'USHazmatClass6', 'USHazmatClass7', 'USHazmatClass8',
                    'USHazmatClass9', 'otherHazmatExplosive', 'otherHazmatGeneral', 'otherHazmatHarmfulToWater'
                ],
                'vehicle load type'),
                converter: converters.arrayOfStrings
            },
            /**
             * A setter and getter for 'constantSpeedConsumptionInLitersPerHundredkm' attribute.
             * 
             * Specifies the speed-dependent component of consumption.
             * Provided as an unordered list of speed/consumption-rate pairs. The list defines points on a
             * consumption curve.
             * Consumption rates for speeds not in the list are found as follows:
             *   *  by linear interpolation, if the given speed lies in between two speeds in the list
             *   *  by linear extrapolation otherwise, assuming a constant (ΔConsumption/ΔSpeed) determined by
             * the nearest two points in the list.
             *
             * The list must contain between 1 and 25 points (inclusive), and may not
             * contain duplicate points for the same speed. If it only contains a single point,
             * then the consumption rate of that point is used without further processing.
             * Consumption specified for the largest speed must be greater than or equal to that of the
             * penultimate largest speed. This ensures that extrapolation does not lead to negative consumption rates.
             * Similarly, consumption values specified for the two smallest speeds in the list cannot lead to a
             * negative consumption rate for any smaller speed.
             * The minimum and maximum values described here refer to the valid range for the consumption values
             * (expressed in l/100km).
             * @method constantSpeedConsumptionInLitersPerHundredkm
             * @chainable
             * @param {Array} [constantSpeedConsumptionInLitersPerHundredkm] Colon-delimited list of
             * CombustionConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Array} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            constantSpeedConsumptionInLitersPerHundredkm: {
                postValidator: postValidators.constantSpeedConsumption('combustion'),
                converter: converters.constantSpeedConsumption
            },
            /**
             * A setter and getter for 'currentFuelInLiters' attribute.
             * 
             * Specifies the current supply of fuel in liters.
             * @method currentFuelInLiters
             * @chainable
             * @param {Number} [currentFuelInLiters]
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            currentFuelInLiters: {
                postValidators: postValidators.floatAndEngineType('combustion', 'currentFuelInLiters')
            },
            /**
             * A setter and getter for 'auxiliaryPowerInLitersPerHour' attribute.
             * 
             * Specifies the amount of fuel consumed for sustaining auxiliary systems of the vehicle, in liters
             *  per hour. It can be used to specify consumption due to devices and systems such as AC systems, radio,
             * heating, etc.
             * @method auxiliaryPowerInLitersPerHour
             * @chainable
             * @param {Number} [auxiliaryPowerInLitersPerHour]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            auxiliaryPowerInLitersPerHour: {
                postValidators: postValidators.floatAndEngineType('combustion', 'auxiliaryPowerInLitersPerHour')
            },
            /**
             * A setter and getter for 'fuelEnergyDensityInMJoulesPerLiter' attribute.
             * 
             * Specifies the amount of chemical energy stored in one liter of fuel in megajoules (MJ).
             * It is used in conjunction with the *Efficiency parameters for conversions between saved
             * or consumed energy and fuel.
             * For example, energy density is 34.2 MJ/l for gasoline, and 35.8 MJ/l for Diesel fuel.
             * @method fuelEnergyDensityInMJoulesPerLiter
             * @chainable
             * @param {Number} [fuelEnergyDensityInMJoulesPerLiter]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            fuelEnergyDensityInMJoulesPerLiter: {
                postValidator: postValidators.fuelEnergyDensityInMJoulesPerLiter
            },
            /**
             * A setter and getter for 'accelerationEfficiency' attribute.
             * 
             * Specifies the efficiency of converting chemical energy stored in fuel to kinetic energy when the
             * vehicle accelerates (i.e. KineticEnergyGained/ChemicalEnergyConsumed).
             * ChemicalEnergyConsumed is obtained by converting consumed fuel to chemical energy using
             * fuelEnergyDensityInMJoulesPerLiter.
             * @method accelerationEfficiency
             * @chainable
             * @param {Number} [accelerationEfficiency]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            accelerationEfficiency: {
                postValidator: postValidators.efficiencyParameter('accelerationEfficiency', 'decelerationEfficiency')
            },
            /**
             * A setter and getter for 'decelerationEfficiency' attribute.
             * 
             * Specifies the efficiency of converting kinetic energy to saved (not consumed) fuel when the
             * vehicle decelerates (i.e. ChemicalEnergySaved/KineticEnergyLost).
             * ChemicalEnergySaved is obtained by converting saved (not consumed) fuel to energy using
             * fuelEnergyDensityInMJoulesPerLiter.
             * @method decelerationEfficiency
             * @chainable
             * @param {Number} [decelerationEfficiency]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            decelerationEfficiency: {
                postValidator: postValidators.efficiencyParameter('decelerationEfficiency', 'accelerationEfficiency')
            },
            /**
             * A setter and getter for 'uphillEfficiency' attribute.
             * 
             * Specifies the efficiency of converting chemical energy stored in fuel to potential energy
             * when the vehicle gains elevation (i.e. PotentialEnergyGained/ChemicalEnergyConsumed).
             * ChemicalEnergyConsumed is obtained by converting consumed fuel to chemical energy using
             * fuelEnergyDensityInMJoulesPerLiter.
             * @method uphillEfficiency
             * @chainable
             * @param {Number} [uphillEfficiency]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            uphillEfficiency: {
                postValidator: postValidators.efficiencyParameter('uphillEfficiency', 'downhillEfficiency')
            },
            /**
             * A setter and getter for 'downhillEfficiency' attribute.
             * 
             * Specifies the efficiency of converting potential energy to saved (not consumed) fuel when the
             * vehicle loses elevation (i.e. ChemicalEnergySaved/PotentialEnergyLost).
             * ChemicalEnergySaved is obtained by converting saved (not consumed) fuel to energy using
             * fuelEnergyDensityInMJoulesPerLiter.
             * @method downhillEfficiency
             * @chainable
             * @param {Number} [downhillEfficiency]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            downhillEfficiency: {
                postValidator: postValidators.efficiencyParameter('downhillEfficiency', 'uphillEfficiency')
            },
            /**
             * A setter and getter for 'constantSpeedConsumptionInkWhPerHundredkm' attribute.
             * 
             * Specifies the speed-dependent component of consumption.
             * Provided as an unordered list of speed/consumption-rate pairs. The list defines points
             * on a consumption curve.
             * Consumption rates for speeds not in the list are found as follows:
             * *    by linear interpolation, if the given speed lies in between two speeds in the list
             * *    by linear extrapolation otherwise, assuming a constant (ΔConsumption/ΔSpeed) determined by
             * the nearest two points in the list
             *
             * The list must contain between 1 and 25 points (inclusive), and may not contain duplicate points
             * for the same speed. If it only contains a single point, then the consumption rate of that point
             * is used without further processing. Consumption specified for the largest speed must be greater
             * than or equal to that of the penultimate largest speed.
             * This ensures that extrapolation does not lead to negative consumption rates.
             * Similarly, consumption values specified for the two smallest speeds in the list cannot lead to a
             * negative consumption rate for any smaller speed.
             * The minimum and maximum values described here refer to the valid range for the consumption values
             * (expressed in kWh/100km).
             * @method constantSpeedConsumptionInkWhPerHundredkm
             * @chainable
             * @param {Array} [constantSpeedConsumptionInkWhPerHundredkm] Colon-delimited list of
             * ElectricConstantSpeedConsumptionPairs, e.g. array of such pairs "60,7".
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Array} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            constantSpeedConsumptionInkWhPerHundredkm: {
                postValidator: postValidators.constantSpeedConsumption('electric'),
                converter: converters.constantSpeedConsumption
            },
            /**
             * A setter and getter for 'currentChargeInkWh' attribute.
             * 
             * Specifies the current electric energy supply in kilowatt hours (kWh).
             * @method currentChargeInkWh
             * @chainable
             * @param {Number} [currentChargeInkWh]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            currentChargeInkWh: {
                postValidator: postValidators.chargeParameter('currentChargeInkWh', 'maxChargeInkWh')
            },
            /**
             * A setter and getter for 'maxChargeInkWh' attribute.
             * 
             * Specifies the maximum electric energy supply in kilowatt hours (kWh) that may be stored in t
             * he vehicle's battery.
             * @method maxChargeInkWh
             * @chainable
             * @param {Number} [maxChargeInkWh]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            maxChargeInkWh: {
                postValidator: postValidators.chargeParameter('maxChargeInkWh', 'currentChargeInkWh')
            },
            /**
             * A setter and getter for 'auxiliaryPowerInkW' attribute.
             * 
             * Specifies the amount of power consumed for sustaining auxiliary systems, in kilowatts (kW).
             * It can be used to specify consumption due to devices and systems such as AC systems, radio, heating, etc.
             * @method auxiliaryPowerInkW
             * @chainable
             * @param {Number} [auxiliaryPowerInkW]
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {Number} Method returns the service instance allowing chaining or current value if
             * argument is omitted.
             */
            auxiliaryPowerInkW: {
                postValidator: postValidators.floatAndEngineType('electric', 'auxiliaryPowerInkW')
            },

            /**
             * A setter and getter for _'protocol'_ attribute. 
             * 
             * Represents type of protocol used to perform service call.
             *
             * @method protocol
             * @chainable
             * @param {String} [protocol] Protocol type, one of _http_ or _https_.
             * @throws {TypeError} If the given argument cannot be converted to a valid value.
             * @return {String} Method returns the service instance allowing chaining or _protocol_
             * value if argument is omitted.
             */
            protocol: {
                validator: validators.oneOfValue(['http', 'https'], 'protocol')
            },

            /**
             * A getter and setter for the 'avoidAreas' attribute.
             *
             * A list of shapes to avoid for planning routes. Supported shapes include rectangles.
             * Can contain one of each supported shapes element.

             * @example
             * ```js
             * tomtom.routing().locations('52.37173,4.91015:52.36357,4.898046255')
             * .avoidAreas([{
             *      southWestCorner: {latitude: 52.36391, longitude:4.90106},
             *      northEastCorner: {latitude: 52.36554, longitude:4.90767}
             * }]);
             * ```
             * Supported point formats:
             * - 'lat,lon'
             * - {lat:111, lon:111}
             * - {lat:111, lng:111}
             * - {latitude:111, longitude:111}
             * - {x:111, y:111}
             * - {lat: function(), lng:function()}
             *
             * @method avoidAreas
             * @chainable
             * @param {Object[]} [areas] A list of shapes to avoid for planning routes.
             * @throws {TypeError} if the given argument cannot be converted to a valid value
             * @return {String} Method returns the service instance allowing chaining or converted locations
             *     value if argument is omitted.
             */
            avoidAreas: {
                converter: converters.avoidAreas,
                application: parameterApplications.POST
            },

            /**
             * A getter and setter for the 'avoidVignette' attribute.
             *
             * List of 3-character ISO 3166-1 alpha-3 country codes of countries in which
             * all toll roads with vignettes are to be avoided.
             * Toll roads with vignettes in countries not in the list are unaffected.
             * It is an error to specify both avoidVignette and allowVignette.
             * @method avoidVignette
             * @chainable
             * @param {String|String[]} [newValue] Array of country codes
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String|String[]} The same service instance or the current option value if no argument was given
             */
            avoidVignette: {
                validator: validators.countrySetAlpha3.bind(this, false),
                postValidator: postValidators.firstParamCannotBeUsedWithSecond('avoidVignette', 'allowVignette'),
                converter: converters.arrayOfStrings,
                application: parameterApplications.POST
            },

            /**
             * A getter and setter for the 'allowVignette' attribute.
             *
             * List of 3-character ISO 3166-1 alpha-3 country codes of countries in which
             * toll roads with vignettes are allowed.
             * Specifying allowVignette with some countries X is equivalent to specifying
             * avoidVignette with all countries but X.
             * Specifying allowVignette with an empty list is the same as avoiding all toll roads with vignettes.
             * It is an error to specify both avoidVignette and allowVignette.
             * @method allowVignette
             * @chainable
             * @param {String|String[]} [newValue] Array of country codes
             * @throws {TypeError} If the given argument cannot be converted into a valid value
             * @return {String|String[]} The same service instance or the current option value if no argument was given
             */
            allowVignette: {
                validator: validators.countrySetAlpha3.bind(this, true),
                postValidator: postValidators.firstParamCannotBeUsedWithSecond('allowVignette', 'avoidVignette'),
                converter: converters.arrayOfStrings,
                application: parameterApplications.POST
            }
        };
        return fields;
    });



// WEBPACK FOOTER //
// ./services/routing/commonRoutingParameters.js